<template>
  <v-card
    flat
  >
    <v-card-title>Edit Profile</v-card-title>

    <v-card-text>
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="formProfile.addressLine1"
          label="Address Line 1"
          :rules="[() => !!formProfile.addressLine1 || 'Address is required']"
          required
        ></v-text-field>

        <v-text-field
          v-model="formProfile.addressLine2"
          label="Address Line 2"
        ></v-text-field>

        <v-text-field
          v-model="formProfile.addressCity"
          label="City"
          :rules="[() => !!formProfile.addressCity || 'City is required']"
          required
        ></v-text-field>

        <v-text-field
          v-model="formProfile.addressState"
          label="State"
          :rules="[() => !!formProfile.addressState || 'State is required']"
          required
        ></v-text-field>

        <v-text-field
          v-model="formProfile.addressPostalCode"
          label="Postal Code"
          :rules="[
            () => !!formProfile.addressPostalCode || 'Postal Code is required',
            rules.number
          ]"
          required
        ></v-text-field>

        <v-select
          v-model="formProfile.addressCountry"
          :items="countries"
          item-text="name"
          item-value="code"
          label="Country"
          :rules="[() => !!formProfile.addressCountry || 'Country is required']"
          required
        ></v-select>

        <div v-if="formProfile.addressCountry != 'US'">
          <p class="red--text">We will contact you to complete a W8 IRS form</p>
        </div>

        <vue-tel-input-vuetify :preferredCountries="['US']"
          :success="phone.valid"
          :error="phone.error"
          :defaultCountry="formProfile.addressCountry"
          v-model="formProfile.phoneNumber"
          @input="phoneInput"
        />

        <v-card class="mb-8 pa-5" v-if="!profile.complete">
          <v-card-title>Identity Information

            <template>
              <v-row>
                <v-dialog
                  v-model="dialog"
                  hide-overlay
                  transition="dialog-bottom-transition"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon
                      v-bind="attrs"
                      v-on="on"
                      class="pl-8"
                    >
                    mdi-account-question
                    </v-icon>
                  </template>
                  <v-card>
                    <v-toolbar
                      dark
                      color="primary"
                    >
                      <v-btn
                        icon
                        dark
                        @click="dialog = false"
                      >
                        <v-icon>mdi-close</v-icon>
                      </v-btn>
                      <v-toolbar-title>BlueChipCar Share Purchase Requirements</v-toolbar-title>
                    </v-toolbar>
                    <v-list
                      three-line
                      subheader
                    >
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title>Why am I being asked to provide my SSN or complete a W-8?</v-list-item-title>
                          <v-spacer></v-spacer>
                          <div class="body-2">
                            <p style="padding-top: 20px;">In order to complete a transaction it is required to have full name and mailing address on record.  US citizens require a social security number. Non-US citizens are asked to complete a  W-8 form.  The information provided is required to properly file tax information, should users earn $600+ a year and receive a 1099 tax form.</p>
                            <p>Your information is encrypted and is only used for verification, processing withdrawals, and tax information. BlueChipCar will not sell or share your data with any third parties.</p>
                          </div>
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="primary"
                        text
                        @click="dialog = false"
                      >
                        Close
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
              </v-row>
            </template>
          </v-card-title>


          <v-text-field
            v-model="formProfile.firstName"
            label="First Name"
            :rules="[
              () => !!formProfile.firstName || 'First Name is required',
            ]"
            required
          ></v-text-field>

          <v-text-field
            v-model="formProfile.lastName"
            label="Last Name"

            required
          ></v-text-field>

          <v-text-field
            v-if="!profile.complete && formProfile.addressCountry === 'US'"
            v-model="formProfile.idNumber"
            :append-icon="showSsn ? 'mdi-eye' : 'mdi-eye-off'"
            label="SSN"
            counter
            maxlength="9"
            :type="showSsn ? 'text' : 'password'"
            @click:append="showSsn = !showSsn"
            :rules="[
              () => !!formProfile.idNumber || 'SSN is required',
              rules.number,
              rules.idLength
            ]"
            required
          ></v-text-field>

          <v-checkbox
            v-model="formProfile.secTermsAgreement"
          >
            <template v-slot:label>
              <div>
                I agree with the BCC
                 <v-tooltip bottom>
                   <template v-slot:activator="{ on }">
                     <a
                       target="_blank"
                       href="/terms-conditions"
                       @click.stop
                       v-on="on"
                     >
                       Terms and Conditions
                     </a>
                   </template>
                   Opens in a new window.
                 </v-tooltip>
                  and I am comfortable and knowledgeable about making investments.
              </div>
            </template>
          </v-checkbox>
        </v-card>
      </v-form>
    </v-card-text>

    <v-card-actions>
      <v-btn
        color="primary"
        :loading="loading"
        :disabled="loading"
        @click="updateProfile"
      >
        <v-icon left>
          mdi-content-save
        </v-icon>
        Save
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  export default {
    name: 'ProfileForm',

    components: {
    },

    computed: {
      ...mapGetters([
        'profile',
        'countries'
      ])
    },

    data: () => ({
      loading: false,
      showSsn: false,
      formProfile: {},
      phone: {
        valid: false,
        error: false
      },
      valid: true,

      // validation rules
      rules: {
        idLength: value => {
          return value.length === 9 || 'SSN must be 9 digits.'
        },
        number: value => {
          return !isNaN(parseFloat(value)) && isFinite(value) || 'Must be numeric.'
        }
      },

      dialog: false,
      notifications: false,
      sound: true,
      widgets: false,

    }),

    methods: {
      ...mapActions([
        'updateUserProfile'
      ]),

      phoneInput(formattedNumber, phoneObj) {
        this.phone.valid = phoneObj.valid
        if (phoneObj.valid) {
          this.phone.error = false
        }
      },

      updateProfile: function () {
        this.loading = true

        // Check validation
        this.$refs.form.validate()

        if (!this.phone.valid) {
          this.valid = false
          this.phone.error = true
        }

        if (this.valid == true) {
          // Update profile.
          this.updateUserProfile(this.formProfile).then(() => {
            let assetBounce = this.$cookies.get('assetBounce')

            if (this.profile.complete && assetBounce) {
              this.$cookies.remove('assetBounce', '/')
              this.$router.push({ path: `/flip/${assetBounce}` })
            }

            this.$emit('dialog-close')
            this.loading = false
          })
        }
        else {
          this.loading = false
        }
      }
    },

    created() {
      // Duplicate the profile store to prevent confusion by
      // directly updating state.
      this.formProfile = Object.assign({}, this.profile)
      this.formProfile.idNumber = ''
    }
  }
</script>
